// extracted by mini-css-extract-plugin
module.exports = {"content":"ProjectInsightsFrequency-module_content__XpwpTNrVXXanaGXcI0JC","csvDownloadWrap":"ProjectInsightsFrequency-module_csvDownloadWrap__P3OeeKgdXv3SEG3bAoZr"};